import React from 'react';
import PropTypes from 'prop-types';
import locationUtils from '../../../../lib/utils/location';
import globalStyles from '../../../globals.scss';
import styles from './Brand.scss';

const BrandShow = ({ selectedBrand, readOnly }) => {
  const exists = (
    selectedBrand.brand_header
  );
  return (
    <div>
      {exists &&
        <div className={[styles.header, !readOnly ? styles.headerEdit : ''].join(' ')}>
          {selectedBrand.brand_header &&
            <div dangerouslySetInnerHTML={{ __html: selectedBrand.brand_header }} />
          }
        </div>
      }
      {!exists && !readOnly &&
        <div>
          <div>
            <strong>
              Your Company Name
            </strong>
          </div>
          <div className={globalStyles.subtext}>
            (555) 555-1212
          </div>
          <div className={globalStyles.subtext}>
            info@yourcompany.com
          </div>
          <div className={globalStyles.subtext}>
            123 Elm Street
          </div>
          <div className={globalStyles.subtext}>
            {locationUtils.getLocalityString(
              'San Francisco',
              'CA',
              '94105'
            )}
          </div>
        </div>
      }
    </div>
  );
};

BrandShow.propTypes = {
  selectedBrand: PropTypes.object.isRequired,
  readOnly: PropTypes.bool
};

export default BrandShow;



// WEBPACK FOOTER //
// ./webpack/components/Document/Sections/Brand/BrandShow.js